/* eslint-disable @typescript-eslint/explicit-function-return-type */
import * as React from 'react'
import { view } from 'react-easy-state'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import ButtonChakra from '../../components/generics/ButtonChakra'
import { Box, Image } from '@chakra-ui/react'
import * as validate from '../../core/utils/Validate'
import userStore from '../../core/stores/Viriyah/userStore'

interface Form {
  errorMessage: validate.ErrorStatus
}

let firstTimeUse = false

export default view(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [form, setForm] = React.useState<Form>({
    errorMessage: { message: '', status: false }
  })

  const confirmClickPDPA = (): unknown => navigate('/PDPA-page', { replace: true })

  React.useEffect(() => {
    if (!firstTimeUse) {
      loginSuccess()
      firstTimeUse = true
    }
  })

  const isDisable = false

  const loginSuccess = () => {
    const pathName = 'loginSuccess'
    const payload = {
      userId: userStore.userId
    }
    setForm({
      ...form,
      errorMessage: { message: '', status: false }
    })
    window.bizlink
      .trigger('POST', {
        payload,
        pathName
      })
      .then((response: any) => {
        if (response.status !== 'success') {
          // alert('ไม่มีข้อมูลลูกค้า กรุณาสมัครสมาชิกใหม่')
          navigate('/terms-and-cond', { replace: true })
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  return (
    <>
      <div
        dangerouslySetInnerHTML={{
          __html: form.errorMessage.status
            ? `${t('viriyah.validate-message.login-form.logo')} <div style='width: 90%; padding-left: 2%;'><p> ${t(
                form.errorMessage.message
              )} </p></div></div>`
            : ''
        }}
      />
      <section className="duplicate-alert">
        <div id="alertDv-claim">
          <Box height="auto" display="flex" justifyContent="center">
            <Image boxSize="100px" src={t('viriyah.login-success-page.logo')} alt="alertLogo" />
          </Box>
          <div id="title">{t('viriyah.login-success-page.title')}</div>
          <div id="description" dangerouslySetInnerHTML={{ __html: t('viriyah.login-success-page.description') }} />
        </div>

        <div className="bottom-section">
          <ButtonChakra customBgColor="#0033A2" textColor="white" isDisable={isDisable} onClick={confirmClickPDPA}>
            {t('viriyah.login-success-page.btn')}
          </ButtonChakra>
        </div>
      </section>
    </>
  )
})
